import { produce } from 'immer';
import { set } from 'lodash';

import { UpdateInternalBannerDescription } from '../../../actions/bannersEdit/internal/updateInternalBannerDescription';
import { EditInternalBannersState } from '../../../typings/internalBannersEditState';

export function updateInternalBannerDescription(
    state: EditInternalBannersState,
    action: UpdateInternalBannerDescription
): EditInternalBannersState {
    return produce(state, draft => {
        const { value, bannerId } = action;

        if (draft.banners[bannerId].errors) {
            set(draft.banners[bannerId], 'errors.description.errors', []);
        }

        draft.banners[bannerId].description = value;
    });
}
